<script lang="ts" setup>
import AdvantageCard from '~/components/cards/AdvantageCard.vue'
import PartnerBox from '~/components/partner/PartnerBox.vue'
import type { Advantage } from '~/types/advantages'

const advantages: Advantage[] = [
  {
    iconName: 'outlined/verify',
    title: 'Доверие клиентов\xA0— мы\xA0проверяем каждый бренд\xA0БАД'
  },
  {
    iconName: 'outlined/cash',
    title: 'Пассивный доход\xA0— зарабатывайте, даже\xA0когда спите'
  },
  {
    iconName: 'outlined/many-people',
    title: 'Поддержка комьюнити\xA0— вы\xA0никогда не\xA0останетесь без\xA0ответа'
  },
  {
    iconName: 'outlined/monitor',
    title: 'Гибкость\xA0— работайте в\xA0удобном для\xA0себя формате'
  }
]
</script>

<template>
  <PartnerBox class="my-2 flex flex-col md:flex-row md:space-x-4">
    <div
      class="
        relative mb-4 flex items-center overflow-hidden rounded-2xl bg-main-blue px-3 py-8 text-center text-lg
        font-medium text-white md:mb-0 md:w-1/2 md:rounded-3xl md:px-8 md:text-4xl
      "
    >
      <div
        class="absolute bottom-0 right-0 z-10 size-full bg-cover bg-center bg-no-repeat"
        :style="`background-image: url(https://storage.yandexcloud.net/itab.pro/partner/background%20pattern.png)`"
      />

      <span class="relative z-20">Почему специалисты выбирают&nbsp;iTAB</span>
    </div>
    <div class="flex flex-col space-y-2.5 md:w-1/2 md:space-y-3">
      <AdvantageCard v-for="x in advantages" :key="x.title" :advantage="x" class="!bg-[#F1F1F1]" />
    </div>
  </PartnerBox>
</template>
